import Entity from "./Entity";

import _ from 'lodash';

const validationEntityFieldsWithDynamicAllowedValues = {
  type: { enumName: 'ValidationTypeEnum' }
};

export default class Validation {
  fields = {
    id: {
      value: null
    },
    quantity: {
      value: null
    },
    type: {
      value: null
    },
    product_name: {
      value: null
    }
  }

  static createFromQueryValues(values) {
    const validation = new this();

    for (let field in validation.fields) {
      if (values.hasOwnProperty(field)) {
        validation.fields[field].value = values[field];
      }
    }

    return validation;
  }

  static getFieldAllowedValues(fields) {
    return Entity.getFieldAllowedValues(
      {},
      validationEntityFieldsWithDynamicAllowedValues,
      fields
    );
  }

  getQueryFieldValues() {
    const values = _.cloneDeep(ValidationInput);

    values.quantity = this.fields.quantity.value;
    values.type = this.fields.type.value;
    values.product_name = this.fields.product_name.value;

    return values;
  }
}

export const ValidationInput = {
  quantity: null,
  type: null,
  product_name: null
}